import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Message, translator } from 'mage-i18n';
import {
  IllustrationChallengeStatusQuo,
  Loader,
  Typography,
  SpacerHorizontal,
  SpacerVertical,
} from '@klarna/bubble-ui';
import { analytics, defaultContainerPropTypes } from 'moet-core';

import {
  getCreatedMerchantId,
  getRegionOfSignupCountry,
  getSetupData,
  getWidgetUrl,
  isExistingUser,
} from '@/selectors/data';
import { MessagingStep, withReCaptchaProtectedCapability } from '@/components';
import { CAPS } from '@/constants';
import { ANALYTICS_EVENTS } from './analyticsEvents';

const tPrefix = 'products-fe.containers.account_creation_loading';

export const AccountCreationLoading = ({
  isExistingUser,
  merchantId,
  onBack,
  onNext,
  region,
  setupData,
  setupPost,
  t,
  widgetUrl,
}) => {
  const [setupCallMade, setSetupCallMade] = useState(false);

  useEffect(() => {
    if (merchantId && widgetUrl) {
      analytics.login({
        customerid: merchantId,
        callback: () => {
          document.location.href = widgetUrl;
        },
      });
    }
    if (isExistingUser) {
      onNext();
    }
  }, [merchantId, widgetUrl, isExistingUser]);

  useEffect(() => {
    if (!setupCallMade) {
      setSetupCallMade(true);
      setupPost({ body: setupData, region }, async ({ error, payload }) => {
        if (error) {
          onBack();
        } else {
          analytics.logEvent(ANALYTICS_EVENTS.accountSetup, setupData);

          await window.friendbuyAPI.push([
            'track',
            'sign_up',
            { email: setupData.email, id: payload.data.merchantId },
            true,
          ]);
        }
      });
    }
  }, [setupData, setupCallMade]);

  return (
    <MessagingStep
      illustration={<IllustrationChallengeStatusQuo />}
      title={[t(`${tPrefix}.title`)]}
    >
      <SpacerVertical small />
      <Typography textToken="text-style/text/super-paragraphs/tall/regular">
        <div style={{ display: 'flex' }}>
          <div style={{ paddingTop: '3px' }}>
            <Loader />
          </div>
          <SpacerHorizontal small />
          <Message path={`${tPrefix}.message`} />
        </div>
      </Typography>
    </MessagingStep>
  );
};

AccountCreationLoading.propTypes = {
  ...defaultContainerPropTypes,
  t: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  merchantId: PropTypes.string,
  region: PropTypes.string,
  widgetUrl: PropTypes.string,
};

export default compose(
  connect(state => ({
    isExistingUser: isExistingUser(state),
    merchantId: getCreatedMerchantId(state),
    region: getRegionOfSignupCountry(state),
    setupData: getSetupData(state),
    t: translator(state),
    widgetUrl: getWidgetUrl(state),
  })),
  withReCaptchaProtectedCapability({ setupPost: CAPS.SETUP_POST }),
)(AccountCreationLoading);
